import React from "react";

export default function NeedInsurance(props) {
  const callUs = props?.RightImage?.content?.list_item
  return (
    <div className="sub-wrapper auto-insurance-section">
      <h1>{props?.RightImage?.content?.header[0]?.headline}</h1>
      <p>{props?.RightImage?.content?.header[0]?.subheadline}</p>
      <div className="container">
        <h2 className="pb-3">{props?.LeftImage?.content?.configuration[0]?.headline}</h2>
        <div className="row">
          <div className="col-sm-12 col-md-5">
            {props?.LeftImage?.content?.buttons?.map((item) => {
              return (
                <>
                  <a
                    className="online-quote"
                    href={item.link_url}
                    target={item.link_target}
                  >
                    <div>
                      <img
                        src={item?.link_icon?.filename}
                        alt={item?.link_icon?.alt}
                      />
                      <span>{item.link_text}</span>
                    </div>
                  </a>
                </>
              );
            })}
          </div>

          <div className="col-sm-12 col-md-2">
            <div className="or-section">Or</div>
          </div>
          <div className="col-sm-12 col-md-5">
            <div className="contactus-section">
              {/* {props?.RightImage?.content?.list_item?.map((data) => { */}
                {/* // return ( */}
                  <>
                    <div className="phone">
                      <img alt={callUs[0]?.icon_image?.alt}
                        src={callUs[0]?.icon_image?.filename} />
                      <div className="contact-number">
                        <div className="text">{callUs[0]?.list_text}</div>
                        <div className="phone-number text-orange orange-link">
                          <a href={'tel:'+ callUs[0]?.description?.content[0]?.content[0]?.text}><b>{callUs[0]?.description?.content[0]?.content[0]?.text}</b></a>
                        </div>
                      </div>
                    </div>
                  </>

                  <>
                    <div className="phone">
                      <img alt={callUs[1]?.icon_image?.alt} src={callUs[1]?.icon_image?.filename} />
                      <div className="contact-number">
                        <div className="text">{callUs[1]?.list_text}</div>
                        <div className="phone-number">
                          {callUs[1]?.description?.content[0]?.content[0]?.text}
                        </div>
                      </div>
                    </div>
                  </>
                {/* ); */}
              {/* })} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
